import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import "./projects.css"
import { Helmet } from 'react-helmet';

 import { ReactComponent as Svg } from "./newSVGs/projects9.svg";
 import { ReactComponent as Svg2 } from "./newSVGs/projects8.svg";
 import { ReactComponent as Svg3 } from "./newSVGs/online-shop.svg";

import { visitedContext } from './visitedContext.js';
import { ColoredContext } from './color.js';
import AnimatedBackgroundSVG from './AnimatedBackgroundSVG.jsx';
import TypingText from './typingText.jsx';
import { MouseHoverContext } from './mousHoverContext.js';
import CircleBackground from './CircleBackground.jsx';
import { ReactComponent as Svg102 } from "./newSVGs/union2.svg";
import { ReactComponent as Heart } from "./newSVGs/heart.svg";

 export default function Project() {
  const { visitedPage, setVisitedPage } = useContext(visitedContext);
const[first,setFirst]=useState(true)
const { currentColor, setCurrentColor } = useContext(ColoredContext);
const {mousehover, setMouseHover}= useContext(MouseHoverContext);
const [visibleElements, setVisibleElements] = useState({}); // Tracks visibility of each element
const elementsRef = useRef([]);


const svgRefs = useRef([]); // Ref array for multiple SVGs
const [blurValues, setBlurValues] = useState([20, 20, 20]); // Array for blur values

useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const index = svgRefs.current.indexOf(entry.target);
        if (index !== -1) {
          const blur = Math.max(0, 5 - entry.intersectionRatio * 5);
          setBlurValues((prev) => {
            const updated = [...prev];
            updated[index] = blur;
            return updated;
          });
        }
      });
    },
    { threshold: Array.from({ length: 11 }, (_, i) => i * 0.1) } // Create thresholds from 0 to 1
  );

  svgRefs.current.forEach((ref) => {
    if (ref) observer.observe(ref);
  });

  return () => {
    svgRefs.current.forEach((ref) => {
      if (ref) observer.unobserve(ref);
    });
  };
}, []);



useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute("data-id");

        // Only update visibility if the element is intersecting
        if (entry.isIntersecting) {
          setVisibleElements((prev) => ({
            ...prev,
            [id]: true, // Set to true only when it intersects
          }));
        }
      });
    },
    { threshold: 1 } // Adjust visibility threshold as needed
  );

  elementsRef.current.forEach((element) => {
    if (element) observer.observe(element);
  });

  return () => {
    elementsRef.current.forEach((element) => {
      if (element) observer.unobserve(element);
    });
  };
}, []);


useEffect(() => {
  setVisitedPage(prev => ({ ...prev, projects: true })); // Adjust timing as needed
}, [visibleElements]);

  useEffect(() => {
    setTimeout(() => {
  setFirst(false)
}, 2300); // Start green animation after yellow animation
}, []);

  
    useEffect(() => {
      if(first)
(function(s,i,u,o,c,w,d,t,n,x,e,p,a,b){(a=Array.from(d.querySelectorAll('svg#' + i.root)).filter(n=> !n.svgatorPlayer)[0]||{}).svgatorPlayer={ready:(function(a){b=[];return function(c){return c?(b.push(c),a.svgatorPlayer):b}})(a)};w[o]=w[o]||{};w[o][s]=w[o][s]||[];w[o][s].push(i);e=d.createElementNS(n,t);e.async=true;e.setAttributeNS(x,'href',[u,s,'.','j','s','?','v','=',c].join(''));e.setAttributeNS(null,'src',[u,s,'.','j','s','?','v','=',c].join(''));p=d.getElementsByTagName(t)[0];p.parentNode.insertBefore(e,p);})('91c80d77',{"root":"e9bYwxgNKvI1","version":"2024-09-05","animations":[{"elements":{"e9bYwxgNKvI9":{"opacity":[{"t":0,"v":0},{"t":1800,"v":0},{"t":2000,"v":1}]},"e9bYwxgNKvI22":{"opacity":[{"t":0,"v":0},{"t":2000,"v":0},{"t":2100,"v":1}]},"e9bYwxgNKvI23":{"opacity":[{"t":0,"v":0},{"t":2100,"v":0},{"t":2200,"v":1}]},"e9bYwxgNKvI24":{"transform":{"data":{"t":{"x":-992.499969,"y":-1143.371552}},"keys":{"o":[{"t":0,"v":{"x":992.499969,"y":2000,"type":"corner"},"e":[0.42,0,1,1]},{"t":200,"v":{"x":992.499969,"y":1032.41,"type":"corner"}}]}}},"e9bYwxgNKvI31":{"opacity":[{"t":50,"v":0},{"t":1600,"v":0},{"t":1800,"v":1}]},"e9bYwxgNKvI32":{"opacity":[{"t":0,"v":0},{"t":1600,"v":0},{"t":1800,"v":1}]},"e9bYwxgNKvI37":{"opacity":[{"t":0,"v":0},{"t":1400,"v":0},{"t":1600,"v":1}]},"e9bYwxgNKvI45":{"transform":{"data":{"t":{"x":-1656.049986,"y":-996.150026}},"keys":{"o":[{"t":0,"v":{"x":1656.049986,"y":1,"type":"corner"},"e":[0.42,0,1,1]},{"t":600,"v":{"x":1656.049986,"y":0,"type":"corner"},"e":[0.42,0,1,1]},{"t":800,"v":{"x":1656.049986,"y":864.4272,"type":"corner"}}]}}},"e9bYwxgNKvI53":{"transform":{"data":{"t":{"x":-557.349992,"y":-1068.149964}},"keys":{"o":[{"t":0,"v":{"x":557.349992,"y":0,"type":"corner"},"e":[0.42,0,1,1]},{"t":400,"v":{"x":557.349992,"y":1,"type":"corner"},"e":[0.42,0,1,1]},{"t":600,"v":{"x":557.349992,"y":932.03644,"type":"corner"}}]}}},"e9bYwxgNKvI78":{"transform":{"data":{"t":{"x":-995.700013,"y":-1004.789215}},"keys":{"o":[{"t":0,"v":{"x":995.700013,"y":0,"type":"corner"},"e":[0.42,0,1,1]},{"t":200,"v":{"x":995.700013,"y":1,"type":"corner"},"e":[0.42,0,1,1]},{"t":400,"v":{"x":995.700013,"y":867.05872,"type":"corner"}}]}}},"e9bYwxgNKvI100":{"opacity":[{"t":0,"v":0},{"t":1200,"v":0},{"t":1400,"v":1}]},"e9bYwxgNKvI194":{"transform":{"data":{"t":{"x":-765.879791,"y":-1136.349945}},"keys":{"o":[{"t":0,"v":{"x":-1000,"y":1035,"type":"corner"},"e":[0.42,0,1,1]},{"t":1000,"v":{"x":-900,"y":1035,"type":"corner"},"e":[0.42,0,1,1]},{"t":1200,"v":{"x":765.88,"y":1035.872925,"type":"corner"}}]}}},"e9bYwxgNKvI299":{"transform":{"data":{"t":{"x":-537.686996,"y":-1454.149841}},"keys":{"o":[{"t":0,"v":{"x":-500,"y":1454.149841,"type":"corner"},"e":[0.42,0,1,1]},{"t":800,"v":{"x":-501,"y":1353,"type":"corner"},"e":[0.42,0,1,1]},{"t":1000,"v":{"x":537,"y":1353.67,"type":"corner"}}]}}}},"s":"MDFA1ZDliNDI4NVDk1SjkyODE5MNDg5OGZYOGUK0MjVhNTI1M0Tw1MEg1MDRjNHDI4NDg5OTJZSODVVODM5NDgL5TjhmOGU0MjBVhTjUxNGM0MWkg4OTk0ODU5BMjgxOTQ4OThPmOGVIOTM0MkFg1YUg1MTRjNSDI4Njg5OGM4UYzQyWDVhUzUFxNGM0MjgxOGGM5NDg1OTI4ZMTgxOTQ4NTQyGNWE4NjgxOGMR5Mzg1NGM0MjVkzOTA4NTg1OIDQ0MjVhNTE0DYzQyODY5MDkRzNDI1YVU1MTAUwNTBTOWQ/"}],"options":"MDKAxMDgyMjk3YITdiNjg3OTdiKMjk0MTI5TDcXzNzY2ODZiMjFlFODQ/"},'https://cdn.svgator.com/ply/','__SVGATOR_PLAYER__','2024-09-05',window,document,'script','http://www.w3.org/2000/svg','http://www.w3.org/1999/xlink')

else
(function(s,i,u,o,c,w,d,t,n,x,e,p,a,b){(a=Array.from(d.querySelectorAll('svg#' + i.root)).filter(n=> !n.svgatorPlayer)[0]||{}).svgatorPlayer={ready:(function(a){b=[];return function(c){return c?(b.push(c),a.svgatorPlayer):b}})(a)};w[o]=w[o]||{};w[o][s]=w[o][s]||[];w[o][s].push(i);e=d.createElementNS(n,t);e.async=true;e.setAttributeNS(x,'href',[u,s,'.','j','s','?','v','=',c].join(''));e.setAttributeNS(null,'src',[u,s,'.','j','s','?','v','=',c].join(''));p=d.getElementsByTagName(t)[0];p.parentNode.insertBefore(e,p);})('91c80d77',{"root":"evUjXVaC8g01","version":"2024-09-05","animations":[{"elements":{"evUjXVaC8g022":{"transform":{"data":{"o":{"x":576.01457,"y":1416.079727,"type":"corner"},"s":{"x":1.5,"y":1.5},"t":{"x":-1443.350525,"y":-462.449997}},"keys":{"r":[{"t":0,"v":360},{"t":15000,"v":540}]}}},"evUjXVaC8g023":{"transform":{"data":{"o":{"x":449.742295,"y":1564.099268,"type":"corner"},"t":{"x":-1364.601685,"y":-627.615173}},"keys":{"r":[{"t":0,"v":0},{"t":15000,"v":360}]}}},"evUjXVaC8g0315":{"opacity":[{"t":0,"v":0},{"t":200,"v":0.38},{"t":900,"v":0.38},{"t":1700,"v":0.38},{"t":2800,"v":0.38},{"t":2900,"v":0},{"t":3000,"v":0.38},{"t":4900,"v":0.38},{"t":5000,"v":0},{"t":7900,"v":0},{"t":8000,"v":0.38},{"t":8100,"v":0},{"t":8200,"v":0.38},{"t":10000,"v":0.38},{"t":10100,"v":0},{"t":10200,"v":0.38},{"t":10300,"v":0},{"t":13000,"v":0},{"t":13100,"v":0.38},{"t":13200,"v":0},{"t":13300,"v":0.38}]}},"s":"MDDA1ZWIwNTc5OVWFhYTc5NmE5ROWVhNGEzNTcB2ZjY2NmE2NTHY1NjU2MTU3OBTk5ZWE3OWE5UOGE5OWVhNGEWzNTc2ZjY2WTHYxNTc5ZWE5OMWFhNzk2YTk5YZWE0YTNhODUJ3NmZONjU2MTLU3OWI5ZWExUWmExNTc2ZjY2BNjE1Nzk2YTFAhOTlhYTdhMzEk2YTlMOWE1NRzZmOWI5NmExCYTg5YTYxNTdDhOGE1OWE5YTTk5NTc2Zlk2NIjYxNTc5YmE1XYTg1NzZmUjYI2UjY1NjVGYjFI/"}],"options":"MDFAxMDgyMjk3YMTdiNjg3OTdiWMjk0MTI5NzMP3NjY4NmIyOTLg0"},'https://cdn.svgator.com/ply/','__SVGATOR_PLAYER__','2024-09-05',window,document,'script','http://www.w3.org/2000/svg','http://www.w3.org/1999/xlink')

}, [first]);

    return (
      <Fragment>
          <Helmet>
        <title>Amirali Soltani | Projects </title>
        <meta name="description" content="Browse Amirali Soltani's web development projects built with React, Node.js, and more." />
        <meta name="keywords" content="Amirali Soltani, Portfolio, Projects, React, Web Developer, Amircode" />
      </Helmet>
      <div className="main-project">
      <svg
      id="ehxIGA7tZv51"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1200 426"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      style={{
        width: "100%",
        position: "absolute",
        top: "0px",
        right: "0px",
        marginTop:"0px",
        overflow:"visible",
        ...(!currentColor.light && { filter: "drop-shadow(2px 4px 6px black)" }),
      }}
    >
      <style>
        {`
          #ehxIGA7tZv52 {
            animation-name: ehxIGA7tZv52_s_do, ehxIGA7tZv52_s_da;
            animation-duration: 6000ms;
            animation-fill-mode: forwards;
            animation-timing-function: linear;
            animation-direction: normal;
            animation-iteration-count: 1;
          }
          @keyframes ehxIGA7tZv52_s_do {
            0% {
              stroke-dashoffset: 3068.41;
            }
            50% {
              stroke-dashoffset: 3068.41;
            }
            100% {
              stroke-dashoffset: 0;
            }
          }
          @keyframes ehxIGA7tZv52_s_da {
            0% {
              stroke-dasharray: 3068.41;
            }
            50% {
              stroke-dasharray: 3068.41;
            }
            100% {
              stroke-dasharray: 3068.41;
            }
          }
        `}
      </style>
      <path
        id="ehxIGA7tZv52"
        d="M1487,352.547c-19.73-26.143-93.65-72.908-231.51-50.822-172.32,27.607-168.84,204.544,25.24,75.92c155.27-102.9,109.3-218.611,58.31-255.368-43.22-31.1623-154.22-74.7901-252.39,0-122.716,93.489-667.54,25.098-935.6-93.4877C-63.3987,-66.0793,-66.0316,114.949,19.6304,200.08C151.05,358.064,139.75,427.63,69.4281,387.474C-0.89418,347.318,24.9415,267.462,122.412,240.897L138,237.5l17-3.5l24-4l24.5-2.5"
        transform="matrix(.769857 0 0 0.82276 50.313972 25.752124)"
        fill="none"
        stroke="#f55"
        strokeWidth="3"
        strokeDashoffset="3068.41"
        strokeDasharray="3068.41"
      />
    </svg>

        <div   className="text">
        <AnimatedBackgroundSVG/>

          <div className="projects-intro">
        <div className='container-zero'   >
          <span className={currentColor.light?"zero zero-first zero-light " : "zero zero-first dark-yellow customize-shadow"}> Diversity Of Projects </span>

            </div>
            <TypingText text="I'm A" classText={currentColor.light?"first intro-dark" : "first intro-light customize-shadow"} delay={1000}  speed={50} />
            <TypingText text="Versatile Tech Specialist"  classText={currentColor.light?"second intro-dark" : "second intro-light customize-shadow"} delay={1400} speed={60} />
            <TypingText text="Showcasing Innovation & Impact"  classText={currentColor.light?"third intro-dark" : "third intro-light customize-shadow"} delay={3000} speed={60} />

            </div>
 
      
        </div>

        {first &&<Svg/>}
        {!first &&<Svg2/>}

      </div>

      <div className="container-projects">
      <div className="title-experience">
      <div className="background">
      <Svg102/>

      </div>
          <div className='title'>
            <span className={currentColor.light? "black-text" : "light-text customize-shadow"}> Project 1 - </span>
            <span className={currentColor.light? "red" : "red customize-shadow"}>Online Shop</span>
                
                </div>
          </div>
          <div className="one-project">
            <div className={visibleElements[1]? "demo dissapear" : "demo"}>
            <img
            className={visibleElements[1]? "shrink" : ""}
                src={require("../src/pics/mock7.jpg")}
                alt=""
              />
            </div>
            <div className="svg-buttons">
           <div className="margin"></div>
         <div className="project-buttons"
         key="1"
         data-id="1"
         ref={(el) => (elementsRef.current[1] = el)}>
    <div className={visibleElements[1]? "live live-appear " : "live live-disappear"}
     onMouseEnter={() => setMouseHover(true)} 
    onMouseLeave={() => setMouseHover(false)}
    onClick={() => window.open("https://online-shop-six-iota.vercel.app/", "_blank")}>
    
    <img
                src={require("../src/pics/eye.png")}
                alt=""
              />
      Live Demo</div>
      <div className={visibleElements[1]? "github github-appear " : "github github-disappear"}
     onMouseEnter={() => setMouseHover(true)} 
    onMouseLeave={() => setMouseHover(false)}
        onClick={() => window.open("https://github.com/AmiraliSoltani/onlineShop", "_blank")}>

    <img
                src={require("../src/pics/github.png")}
                alt=""
              />
      GitHub Code</div>
  </div>
            </div>
         <div className="text">
         <CircleBackground />
         <div className={currentColor.light?" title-details title-details-light " : " title-details title-details-dark customize-shadow"}>
    <span className={visibleElements[1]? "title-appear":"title-dissapear"} >
    Project Overview

    </span>
  </div>
  <div className={currentColor.light?" details details-light" : "details details-dark customize-shadow"}>
  <div className={visibleElements[1]? " handWritting handWritting-appear":" handWritting"} >
  <Heart/>
  </div>
  <span className={visibleElements[1]? "details-appear":"details-dissapear"} >
<div className="margin-bottom">
This project is a React-based online shopping platform delivering an intuitive, seamless user experience. It includes state management with Reducers, RESTful APIs, and secure Google OAuth authentication.</div>
    The back-end uses Node.js and MongoDB for database operations and scalability. It integrates Context API for data sharing and caching with useQuery for performance.
    </span>
  </div>
  <div className="used">
    <div className={currentColor.light?" title-light title" : " title-dark title customize-shadow"}>
    <span className={visibleElements[1]? "title-appear":"title-dissapear"} >

    Key Frameworks      </span>

      </div>
    <div className="tools"
     
    >
      <span 
      className={`${
        visibleElements[1] ? "tools-appear" : "tools-dissapear"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
        React.js
        </span>

        <span 
      className={`${
        visibleElements[1] ? "tools-appear" : "tools-dissapear"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
        Node.js
        </span>

        <span 
      className={`${
        visibleElements[1] ? "tools-appear" : "tools-dissapear"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
        Express.js
        </span>

        <span 
      className={`${
        visibleElements[1] ? "tools-appear" : "tools-dissapear"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
        MongoDB 
        </span>
       

    </div>
  </div>

  <div className="feature"        >
    <div className={currentColor.light?" title-light title" : " title-dark title customize-shadow"}>
    <span className={visibleElements[1]? "feature-appear":"feature-dissapear "} >
    Advanced Features      </span>
      </div>
    <div className="tools">
      <span
      className={`${
        visibleElements[1] ? "feature-appear-2" : "feature-dissapear-2"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
        State Management (Reducers)
        </span>

        <span
      className={`${
        visibleElements[1] ? "feature-appear-2" : "feature-dissapear-2"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
        RESTful API Integration
        </span>

        <span
      className={`${
        visibleElements[1] ? "feature-appear-2" : "feature-dissapear-2"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
        Google Authentication
        </span>

        <span
      className={`${
        visibleElements[1] ? "feature-appear-2" : "feature-dissapear-2"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
        Context API
        </span>

        <span
      className={`${
        visibleElements[1] ? "feature-appear-2" : "feature-dissapear-2"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
       Data Caching (useQuery)
        </span>

      

    </div>
  </div>

  

</div>


          </div>
      </div>



      <div className="container-projects">
      <div className="title-experience">
      <div className="background">
      <Svg102/>

      </div>
          <div className='title'>
            <span className={currentColor.light? "black-text" : "light-text customize-shadow"}> Project 2 - </span>
            <span className={currentColor.light? "red" : "red customize-shadow"}>News Website</span>
                
                </div>
          </div>
          <div className="one-project">
            <div className={visibleElements[2]? "demo dissapear" : "demo"}>
            <img
            className={visibleElements[2]? "shrink" : ""}
                src={require("../src/pics/mock13.jpg")}
                alt=""
              />
            </div>
            <div className="svg-buttons">
            <div className="margin-second"></div>
         <div className="project-buttons"
         key="2"
         data-id="2"
         ref={(el) => (elementsRef.current[2] = el)}>
    <div className={visibleElements[2]? "live live-appear " : "live live-disappear"}
     onMouseEnter={() => setMouseHover(true)} 
    onMouseLeave={() => setMouseHover(false)}
    // onClick={() => window.open("https://online-shop-six-iota.vercel.app/", "_blank")}
    >
    
    <img
                src={require("../src/pics/eye.png")}
                alt=""
              />
      Live Demo</div>
      <div className={visibleElements[2]? "github github-appear " : "github github-disappear"}
     onMouseEnter={() => setMouseHover(true)} 
    onMouseLeave={() => setMouseHover(false)}
        // onClick={() => window.open("https://github.com/AmiraliSoltani/onlineShop", "_blank")}
        >

    <img
                src={require("../src/pics/github.png")}
                alt=""
              />
      GitHub Code</div>
  </div>
            </div>
         <div className="text">
         <CircleBackground />
         <div className={currentColor.light?" title-details title-details-light " : " title-details title-details-dark customize-shadow"}>
    <span className={visibleElements[2]? "title-appear":"title-dissapear"} >
    Project Overview

    </span>
  </div>
  <div className={currentColor.light?" details details-light" : "details details-dark customize-shadow"}>
  {/* <div className={visibleElements[2]? " handWritting handWritting-appear":" handWritting"} >
  <Heart/>
  </div> */}
  <span className={visibleElements[2]? "details-appear":"details-dissapear"} >

  <div className="margin-bottom">
  
  This project is a full-stack news website built with React.js and Node.js, offering real-time news updates and a personalized user experience. The homepage adapts dynamically based on user interests and search history.  </div>


  Users can comment, rate, and engage with articles, while real-time updates and moderation maintain content quality. The Node.js & Express backend manages authentication, comments, and data securely and at scale.






</span>

  </div>
  <div className="used">
    <div className={currentColor.light?" title-light title" : " title-dark title customize-shadow"}>
    <span className={visibleElements[2]? "title-appear":"title-dissapear"} >

    Key Frameworks      </span>

      </div>
    <div className="tools"
     
    >
      <span 
      className={`${
        visibleElements[2] ? "tools-appear" : "tools-dissapear"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
        React.js
        </span>

        <span 
      className={`${
        visibleElements[2] ? "tools-appear" : "tools-dissapear"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
        Node.js
        </span>

        <span 
      className={`${
        visibleElements[2] ? "tools-appear" : "tools-dissapear"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
        Express.js
        </span>

        <span 
      className={`${
        visibleElements[2] ? "tools-appear" : "tools-dissapear"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
        MySQL
        </span>
       

    </div>
  </div>

  <div className="feature"        >
    <div className={currentColor.light?" title-light title" : " title-dark title customize-shadow"}>
    <span className={visibleElements[2]? "feature-appear":"feature-dissapear "} >
    Advanced Features      </span>
      </div>
    <div className="tools">
      <span
      className={`${
        visibleElements[2] ? "feature-appear-2" : "feature-dissapear-2"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
       Real-time API Integration
        </span>

        <span
      className={`${
        visibleElements[2] ? "feature-appear-2" : "feature-dissapear-2"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
State Management (Reducers)
</span>

        <span
      className={`${
        visibleElements[2] ? "feature-appear-2" : "feature-dissapear-2"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
User Authentication        </span>

        {/* <span
      className={`${
        visibleElements[2] ? "feature-appear-2" : "feature-dissapear-2"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
       Comment & Rating System
        </span> */}

        <span
      className={`${
        visibleElements[2] ? "feature-appear-2" : "feature-dissapear-2"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
       Data Caching (useQuery)
        </span>

      

    </div>
  </div>

  

</div>


          </div>
      </div>



      <div className="container-projects">
      <div className="title-experience">
      <div className="background">
      <Svg102/>

      </div>
          <div className='title'>
            <span className={currentColor.light? "black-text" : "light-text customize-shadow"}> Project 3 - </span>
            <span className={currentColor.light? "red" : "red customize-shadow"}>Portfolio</span>
                
                </div>
          </div>
          <div className="one-project">
            <div className={visibleElements[3]? "demo dissapear" : "demo"}>
            <img
            className={visibleElements[3]? "shrink" : ""}
                src={require("../src/pics/mock12.jpg")}
                alt=""
              />
            </div>
            <div className="svg-buttons">
            <div className="margin-third"></div>

         <div className="project-buttons"
         key="3"
         data-id="3"
         ref={(el) => (elementsRef.current[3] = el)}>
    <div className={visibleElements[3]? "live live-appear " : "live live-disappear"}
     onMouseEnter={() => setMouseHover(true)} 
    onMouseLeave={() => setMouseHover(false)}
    onClick={() => window.open("https:/amircode.ca", "_blank")}>
    
    <img
                src={require("../src/pics/eye.png")}
                alt=""
              />
      Live Demo</div>
      <div className={visibleElements[3]? "github github-appear " : "github github-disappear"}
     onMouseEnter={() => setMouseHover(true)} 
    onMouseLeave={() => setMouseHover(false)}
        onClick={() => window.open("https://github.com/AmiraliSoltani/Portfolio", "_blank")}>

    <img
                src={require("../src/pics/github.png")}
                alt=""
              />
      GitHub Code</div>
  </div>
            </div>
         <div className="text">
         <CircleBackground />
         <div className={currentColor.light?" title-details title-details-light " : " title-details title-details-dark customize-shadow"}>
    <span className={visibleElements[3]? "title-appear":"title-dissapear"} >
    Project Overview

    </span>
  </div>
  <div className={currentColor.light?" details details-light" : "details details-dark customize-shadow"}>
  {/* <div className={visibleElements[3]? " handWritting handWritting-appear":" handWritting"} >
  <Heart/>
  </div> */}
  <span className={visibleElements[3]? "details-appear":"details-dissapear"} >

  <div className="margin-bottom">
  This project is a React-based portfolio website designed to showcase development skills with a modern, responsive, and visually appealing interface. Built using React.js and SCSS, it provides a smooth and dynamic user experience with well-structured components.
  </div>

The website features interactive animations, responsive layouts, and seamless navigation to ensure accessibility across all devices. SCSS enhances maintainability and styling consistency, while React ensures efficient rendering and performance    </span>

  </div>
  <div className="used">
    <div className={currentColor.light?" title-light title" : " title-dark title customize-shadow"}>
    <span className={visibleElements[3]? "title-appear":"title-dissapear"} >

    Key Frameworks
      </span>

      </div>
    <div className="tools"
     
    >
      <span 
      className={`${
        visibleElements[3] ? "tools-appear" : "tools-dissapear"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
        React.js
        </span>

        <span 
      className={`${
        visibleElements[3] ? "tools-appear" : "tools-dissapear"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
       SCSS
        </span>
       

    </div>
  </div>

  <div className="feature"        >
    <div className={currentColor.light?" title-light title" : " title-dark title customize-shadow"}>
    <span className={visibleElements[3]? "feature-appear":"feature-dissapear "} >
    Advanced Features

      </span>
      </div>
    <div className="tools">
      <span
      className={`${
        visibleElements[3] ? "feature-appear-2" : "feature-dissapear-2"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
        State Management (Reducers)
        </span>

        <span
      className={`${
        visibleElements[3] ? "feature-appear-2" : "feature-dissapear-2"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
         Context API
        </span>

        <span
      className={`${
        visibleElements[3] ? "feature-appear-2" : "feature-dissapear-2"
      } ${currentColor.light ? "tools-light" : "tools-dark customize-shadow"}`}
       >
       Responsive Design
        </span>

      

    </div>
  </div>

  

</div>


          </div>
      </div>

      </Fragment>
    )
  }
    